// extracted by mini-css-extract-plugin
module.exports = {"content":"Background_content__nl9yV","title":"Background_title__1SWgk","img":"Background_img__2d01h","con":"Background_con__3HoZW","desc":"Background_desc__14fPg"};